import { render, staticRenderFns } from "./GameThumb.vue?vue&type=template&id=0e97c04a&scoped=true&"
import script from "./GameThumb.vue?vue&type=script&lang=ts&"
export * from "./GameThumb.vue?vue&type=script&lang=ts&"
import style0 from "./GameThumb.vue?vue&type=style&index=0&id=0e97c04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97c04a",
  null
  
)

export default component.exports